import React from 'react';

const AuthContext = React.createContext({
    isStudentLoggedIn: false,
    isFacultyLoggedIn: false,
    setStudentPassword: (password:string) => {},
});

export default AuthContext;